import { render, staticRenderFns } from "./cardGame.vue?vue&type=template&id=3d130961&scoped=true&"
import script from "./cardGame.vue?vue&type=script&lang=js&"
export * from "./cardGame.vue?vue&type=script&lang=js&"
import style0 from "./cardGame.vue?vue&type=style&index=0&id=3d130961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d130961",
  null
  
)

export default component.exports